"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVariantGroups = exports.useUpdateUserCoupon = exports.useConfiguration = exports.useRuleEngine = exports.useCoupons = exports.useShippingTiers = exports.useAnnouncement = exports.useFomoProducts = exports.useBanner = exports.useMenu = exports.useNavbar = exports.NavbarProvider = exports.NavbarContext = void 0;
const react_1 = __importStar(require("react"));
const graphql_1 = require("../graphql");
const helpers_1 = require("../helpers");
const inventory_1 = require("../helpers/inventory");
const types_1 = require("../types");
const navbar_1 = require("../types/navbar");
exports.NavbarContext = (0, react_1.createContext)({
    isReady: false,
    storeId: "",
    isInteractive: false,
    user: null,
    userWithRewardPoints: null,
    menus: [],
    banners: [],
    announcements: [],
    shippingTiers: [],
    coupons: [],
    ruleEngines: [],
    configurations: {
        ORDER_COUNT: 0,
        COD: 0,
        PREPAID_DISCOUNT_PERCENT: 0,
        MAX_COD_AMOUNT: 0,
        MIN_COD_AMOUNT: 0,
        MAX_PREPAID_DISCOUNT: 0,
        GUEST_CHECKOUT: false,
        COD_ENABLED: true,
        PREPAID_ENABLED: true,
        TIMER_TTILE: "",
        TIMER_DESCRIPTION: "",
        TIMER_COLOR: "",
        TIMER_BG_COLOR: "",
        TIMER_END_TIME: "",
        TIMER_START_TIME: "",
        IS_DAILY_TIMER: false,
        TIMER_ENABLED: false,
        GOKWIK_ENABLED: false,
        PPCOD_ENABLED: false,
        PPCOD_AMOUNT: 0,
    },
    ltoProducts: [],
    fomoProducts: [],
    cartItems: [],
    appliedCoupon: null,
    variantGroups: null,
    addUserCoupon: () => { },
    setUserWithRewardPoints: () => { },
    resolve: () => Promise.resolve(null),
});
function NavbarProvider({ children, resolve, storeId, deviceType, isInteractive, cartItems: cartItemsState, appliedCoupon = null, user, }) {
    const [isReady, setIsReady] = (0, react_1.useState)(false);
    const [menus, setMenus] = (0, react_1.useState)([]);
    const [banners, setBanners] = (0, react_1.useState)([]);
    const [announcements, setAnnouncements] = (0, react_1.useState)([]);
    const [shippingTiers, setShippingTiers] = (0, react_1.useState)([]);
    const [ruleEngines, setRuleEngines] = (0, react_1.useState)([]);
    const [coupons, setCoupons] = (0, react_1.useState)([]);
    const [userWithRewardPoints, setUserWithRewardPoints] = (0, react_1.useState)();
    const [configurations, setConfigurations] = (0, react_1.useState)({
        ORDER_COUNT: 0,
        COD: 0,
        PREPAID_DISCOUNT_PERCENT: 0,
        MAX_COD_AMOUNT: 0,
        MIN_COD_AMOUNT: 0,
        MAX_PREPAID_DISCOUNT: 0,
        GUEST_CHECKOUT: false,
        COD_ENABLED: true,
        PREPAID_ENABLED: true,
        TIMER_TTILE: "",
        TIMER_DESCRIPTION: "",
        TIMER_COLOR: "",
        TIMER_BG_COLOR: "",
        TIMER_END_TIME: "",
        TIMER_ENABLED: false,
        TIMER_START_TIME: "",
        IS_DAILY_TIMER: false,
        GOKWIK_ENABLED: false,
        PPCOD_AMOUNT: 0,
        PPCOD_ENABLED: false,
    });
    const [ltoProducts, setLTO] = (0, react_1.useState)([]);
    const [fomoProducts, setFOMO] = (0, react_1.useState)([]);
    const [variantGroups, setVariantGroups] = (0, react_1.useState)(null);
    const cartItems = (0, react_1.useMemo)(() => {
        var _a;
        const cartState = [...cartItemsState].filter((c) => c.cartItemSource !== types_1.CartItemSource.COUPON);
        // if (appliedCoupon?.couponType === CouponType.PRODUCT) {
        const { allowed, coupon: couponResponse } = (0, helpers_1.getCouponDiscount)(appliedCoupon, cartState);
        const { getYStoreProducts } = couponResponse || {};
        if (allowed && !!(getYStoreProducts === null || getYStoreProducts === void 0 ? void 0 : getYStoreProducts.length)) {
            (_a = getYStoreProducts === null || getYStoreProducts === void 0 ? void 0 : getYStoreProducts.filter(Boolean)) === null || _a === void 0 ? void 0 : _a.forEach((getYStoreProduct) => {
                const tmpProduct = Object.assign(Object.assign({}, getYStoreProduct), { recordKey: `${getYStoreProduct.id}-${types_1.CartItemSource.COUPON}`, qty: 1, cartItemSource: types_1.CartItemSource.COUPON, price: Number(getYStoreProduct.price) });
                const variant = (0, helpers_1.getFirstVariant)(getYStoreProduct, null);
                if (variant) {
                    tmpProduct.variantId = variant.id;
                    tmpProduct.price = Number(variant.price);
                    tmpProduct.recordKey = `${tmpProduct.id}-${variant.id}-${types_1.CartItemSource.COUPON}`;
                }
                cartState.push(Object.assign(Object.assign({}, tmpProduct), { listingPrice: Number(tmpProduct.price), thumbImage: (0, helpers_1.thumbImage)(tmpProduct) }));
            });
        }
        // }
        return cartState;
    }, [cartItemsState, appliedCoupon]);
    const getDashboardData = () => {
        resolve(graphql_1.getInitialData, {
            //Collection
            collectionFilter: {
                storeId: { eq: storeId },
                isArchive: { eq: false },
            },
            collectionSort: [{ field: "priority", direction: "asc" }],
            //Coupon , // Rule engine
            storeId,
            deviceType,
            //LtoProduct
            ltoProductFilter: {
                storeId: { eq: storeId },
                recommended: { eq: true },
            },
            ltoProductSort: [{ field: "recommendPriority", direction: "asc" }],
            //GetStoreSetting
            getStoreSettingInput: {
                storeId: storeId,
                deviceType: deviceType,
            },
            menuFilter: {
                storeId: { eq: storeId },
            },
            shippingTierFilter: {
                storeId: { eq: storeId },
            },
            //isFomoProduct
            // fomoProductFilter: {
            //   storeId: { eq: storeId },
            //   isFomo: { eq: true },
            // },
            // fomoProductSort: [{ field: "position", direction: "asc" }],
        })
            .then((response) => {
            var _a, _b;
            //Menu
            setMenus(response.data.searchMenus.items);
            // announcement
            setAnnouncements(response.data.getStore.announcements.filter((a) => !a.isArchive));
            //Store
            setBanners(response.data.getStore.banners.filter((a) => !a.isArchive));
            //Variant Groups
            setVariantGroups(response.data.listVariantGroups);
            //Rule Engine
            setRuleEngines(response.data.byStoreIdRuleEngine.items);
            //Configuration
            setConfigurations(response.data.getStoreSetting.configurations);
            //ShippingTier
            setShippingTiers(response.data.searchShippingTiers.items);
            //Coupon
            setCoupons((response.data.getTopCoupons.items || []).filter((coupon) => {
                const { expirationDate } = coupon;
                return (!expirationDate ||
                    new Date(expirationDate).getTime() >= new Date().getTime());
            }));
            //LtoProduct
            const ltoProducts = ((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.searchProducts) === null || _b === void 0 ? void 0 : _b.items.filter((lto) => {
                var _a, _b, _c;
                const status = ((_b = (_a = lto.variants) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length)
                    ? ((_c = lto.variants) === null || _c === void 0 ? void 0 : _c.items[0].status) === "ENABLED"
                    : lto.status === "ENABLED";
                const { hasInventory } = (0, inventory_1.getProductInventory)(lto, null, response.data.getStoreSetting.configurations.BLOCK_INVENTORY);
                return hasInventory && status;
            })) || [];
            setLTO(ltoProducts);
            //FomoProduct
            // setFOMO(response.data.getFomoProducts.items);
        })
            .catch((e) => {
            console.log("e", JSON.stringify(e));
        })
            .then(() => setIsReady(true));
    };
    const getUserRewardsPoints = async () => {
        var _a;
        if (user) {
            const fetchedUser = await resolve(graphql_1.getUser, { storeId }, navbar_1.AuthMode.AUTH);
            setUserWithRewardPoints((_a = fetchedUser === null || fetchedUser === void 0 ? void 0 : fetchedUser.data) === null || _a === void 0 ? void 0 : _a.getUser);
        }
        return 0;
    };
    (0, react_1.useEffect)(() => {
        if (isInteractive) {
            getDashboardData();
            getUserRewardsPoints();
        }
    }, [isInteractive]);
    const addUserCoupon = async (coupon) => {
        setCoupons((coupons) => [
            Object.assign(Object.assign({}, coupon), { autoApply: true, priority: 0, isExternal: true }),
            ...coupons,
        ]);
    };
    return (react_1.default.createElement(exports.NavbarContext.Provider, { value: {
            isReady,
            storeId,
            user,
            userWithRewardPoints,
            menus,
            banners,
            isInteractive,
            shippingTiers,
            coupons,
            ruleEngines,
            configurations,
            ltoProducts,
            fomoProducts,
            cartItems,
            appliedCoupon,
            addUserCoupon,
            setUserWithRewardPoints,
            resolve,
            announcements,
            variantGroups,
        } }, children));
}
exports.NavbarProvider = NavbarProvider;
const useNavbar = () => (0, react_1.useContext)(exports.NavbarContext);
exports.useNavbar = useNavbar;
const useMenu = () => {
    const { menus } = (0, react_1.useContext)(exports.NavbarContext);
    const sortMenus = (menu) => {
        if (menu.menus && menu.menus.items.length > 0) {
            menu.menus.items = menu.menus.items.sort((menu1, menu2) => menu1.priority - menu2.priority);
            menu.menus.items = menu.menus.items.map(sortMenus);
        }
        return menu;
    };
    if (!!(menus === null || menus === void 0 ? void 0 : menus.length)) {
        const sortedMenuArray = menus.sort((menu1, menu2) => menu1.priority - menu2.priority);
        const sortedMenus = sortedMenuArray.map(sortMenus);
        return sortedMenus;
    }
    return [];
};
exports.useMenu = useMenu;
const useBanner = () => {
    const { banners } = (0, react_1.useContext)(exports.NavbarContext);
    return banners;
};
exports.useBanner = useBanner;
const useFomoProducts = () => {
    const { fomoProducts } = (0, react_1.useContext)(exports.NavbarContext);
    return fomoProducts;
};
exports.useFomoProducts = useFomoProducts;
const useAnnouncement = () => {
    const { announcements } = (0, react_1.useContext)(exports.NavbarContext);
    return announcements;
};
exports.useAnnouncement = useAnnouncement;
const useShippingTiers = () => {
    const { shippingTiers } = (0, react_1.useContext)(exports.NavbarContext);
    return shippingTiers;
};
exports.useShippingTiers = useShippingTiers;
const useCoupons = () => {
    const { coupons } = (0, react_1.useContext)(exports.NavbarContext);
    return coupons;
};
exports.useCoupons = useCoupons;
const useRuleEngine = (event) => {
    const { ruleEngines } = (0, react_1.useContext)(exports.NavbarContext);
    const ruleEngine = ruleEngines.find((engine) => engine.event === event);
    return ruleEngine;
};
exports.useRuleEngine = useRuleEngine;
function useConfiguration(key, defaultValue) {
    const { configurations } = (0, react_1.useContext)(exports.NavbarContext);
    if (!(key in configurations))
        return defaultValue;
    const value = configurations[key];
    if (typeof value === "boolean") {
        return value;
    }
    return value || defaultValue;
}
exports.useConfiguration = useConfiguration;
const useUpdateUserCoupon = () => {
    const { coupons, addUserCoupon, resolve } = (0, react_1.useContext)(exports.NavbarContext);
    const updateUserCoupon = async (couponCode, storeId) => {
        resolve(graphql_1.getCouponRule, {
            code: couponCode,
            storeId,
        })
            .then((res) => res.data.getCouponRule)
            .then(addUserCoupon);
    };
    return [coupons, updateUserCoupon];
};
exports.useUpdateUserCoupon = useUpdateUserCoupon;
const useVariantGroups = () => {
    const { variantGroups } = (0, react_1.useContext)(exports.NavbarContext);
    return variantGroups;
};
exports.useVariantGroups = useVariantGroups;
